/**
 * Route definition for /chains/apothem
 *
 * Renders the shared ChainPage with the `apothem` article. Chain facts live in
 * `@/data/chains`; presentation and SEO live in `@/components/ChainPage`.
 *
 * @module routes/chains/apothem
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import ChainPage from '@/components/ChainPage'

export const Route = createFileRoute('/$locale/chains/apothem')({
  component: function ApothemChainPage() {
    return <ChainPage slug="apothem" />
  },
})
